import { RetirementHistoryView } from "./retirement-history-view";
import { useRetirementHistory } from "./use-retirement-history";

export const RetirementHistory = () => {
  const logic = useRetirementHistory();
  return <RetirementHistoryView {...logic} />;
};
